
export function getscPixelCookie(){
  const match = document.cookie.match(/_scid=([^;]+)/);
  return match ? match[1] : null;
}

export function getscClickIdCookie(){
  const match = document.cookie.match(/scCid=([^;]+)/);
  return match ? match[1] : null;
}

export function lookAndSetClickCookie(scCid){
  document.cookie = `scCid=${encodeURIComponent(scCid)}; path=/; max-age=${60*60*24*30}`;
}
